import { createFileRoute } from '@tanstack/react-router';

import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/my-settings')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: MySettingsRoute
});

function MySettingsRoute() {
  return (
    <>
      <Seo title="My Settings" />
      <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
        <Heading>My Settings</Heading>
      </div>
    </>
  );
}
